import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import LoggedInOrganizer from '../../components/logged-in-user';
import OrganizerAuthentication from '../../components/purchase-claim/organizer-authentication';
import { formSelector as claimFormSelector } from '../../components/purchase-claim/index';
import
  OrganizerAuthenticationWithShare
from '../../components/purchase-claim/organizer-authentication.with-share';
import Purchase from '../../lib/purchase';
import {
  unauthenticateUser,
  userExists,
  fetchDuplicatedPurchase,
} from '../../actions/index';

class OrganizerFields extends Component {
  constructor(props) {
    super(props);
    this.checkUserExistence = debounce(props.userExists, 500, { maxWait: 2000 });
  }

  componentWillMount() {
    const { currentUser, purchaseId, defaultOrganizerEmail } = this.props;

    if (currentUser) {
      this.props.fetchDuplicatedPurchase(purchaseId, currentUser.email);
    }

    if (defaultOrganizerEmail) {
      this.checkUserExistence(defaultOrganizerEmail);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.organizerEmail !== this.props.organizerEmail) {
      this.checkUserExistence(nextProps.organizerEmail);
    }
  }

  onOrganizerEmailBlur(email) {
    this.props.fetchDuplicatedPurchase(this.props.purchaseId, email);
  }

  onLogout() {
    this.props.unauthenticateUser();
  }

  isLoggedIn() {
    return this.props.currentUser;
  }

  isShowingSpecifiedPerPerson() {
    return Purchase.isSpecifiedPerPerson(this.props.splitType);
  }

  render() {
    const { currencyCode, authenticationMethod } = this.props;
    const method = authenticationMethod || 'signup';

    if (this.isLoggedIn()) return <LoggedInOrganizer user={this.props.currentUser} onLogout={() => this.onLogout()} />;

    if (this.isShowingSpecifiedPerPerson()) {
      return (
        <OrganizerAuthenticationWithShare
          currencyCode={currencyCode}
          method={method}
          onEmailBlur={ev => this.onOrganizerEmailBlur(ev.target.value)}
        />
      );
    }

    return (
      <OrganizerAuthentication
        method={method}
        onEmailBlur={ev => this.onOrganizerEmailBlur(ev.target.value)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { users, purchases } = state;
  const purchase = purchases.byId[purchases.current];

  return {
    organizerEmail: claimFormSelector(state, 'organizerEmail'),
    splitType: claimFormSelector(state, 'splitType'),
    currentUser: users.byId[users.current],
    defaultOrganizerEmail: purchase.group.organizerEmail,
    currencyCode: purchase.currencyCode,
    authenticationMethod: users.existence,
    purchaseId: purchase.id,
  };
};

const mapDispatchToProps = {
  unauthenticateUser,
  userExists,
  fetchDuplicatedPurchase,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizerFields);




// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-claim/organizer-fields.container.js